import { ConnectedAppParameter } from "./connected-app";
import { ExternalOperationCommonSettings } from "./external-operation-common-settings";
import { FormTemplate } from "./template";

export enum FormSubmitExternalOperationParameterBindType {
    FORM_AS_PDF = 1,
    CONSTANT_VALUE = 2,
    SCRIPT = 3,
    FIELD_SUBMISSION_PATH = 4
}
export interface FormQueryExternalOperation {
    id?: number;

    unique_name: string;
    
    form_template_id: number;
    form_template: FormTemplate;

    external_operation_common_settings_id: number;
    external_operation_common_settings: ExternalOperationCommonSettings;
}

export interface FormSubmitExternalOperation {
    id?: number;
    
    form_template_id: number;
    form_template: FormTemplate;

    external_operation_common_settings_id: number;
    external_operation_common_settings: ExternalOperationCommonSettings;

    parameters?: FormSubmitExternalOperationParameter[];
}

export interface FormSubmitExternalOperationParameter {
    id?: number;

    bind_type?: FormSubmitExternalOperationParameterBindType;
    constant_value?: string;
    script?: string;
    field_submission_path?: string;

    connected_app_parameter_id: number;
    connected_app_parameter: ConnectedAppParameter;

    form_submit_external_operation_id: number;
    form_submit_external_operation: FormSubmitExternalOperation;
}